import { Logo } from "../../../ui/icons";

export function AuthHeader({ mode }: { readonly mode: "login" | "register" }) {
  return (
    <div className="text-center flex flex-col gap-1">
      <div className="flex items-center justify-center gap-2">
        <Logo className="size-8" />
        <h1 className="text-3xl font-bold text-ink">Palnia</h1>
      </div>
      <p className="text-sm text-ink-muted">
        {mode === "login"
          ? "Connectez-vous à votre compte"
          : "Créez votre compte"}
      </p>
    </div>
  );
}
